class OrderGenerator {
    static Create(productName:string, driverContact:string, driverName:string): any {
        const randomPoId: string = '987' + Math.floor(Math.random() * 1000).toString().padStart(3, '0');
        return {
            driverName: driverName,
            destination: driverContact,
            id: "baa507c2-1d81-4092-a5c2-e80820ee4fd1",
            name: "TO-124",
            externalAttributes: {
              "id": "OrderId"
            },
            description: "TO-124",
            consignments: [
              {
                entity: {
                  id: "e75a541b-e9d9-49e7-8bba-95492d682a6c",
                  creationDate: "2024-10-23T10:00:00Z",
                  externalAttributes: {
                    internalId: "ABC124",
                    purchaseOrderId: randomPoId,
                  },
                  status: "confirmed",
                  goods: [
                    {
                      associationType: "inline",
                      entity: {
                        id: "903807df-ee62-47aa-bf8e-7efd747618ce",
                        description: productName,
                        barCode: "CSE370",
                        productType: "Fruit",
                        quantity: 6,
                        packagingMaterial: "Blokpallet",
                        constraint: {
                          entity: {
                            value: {
                              constraintType: "maximum",
                              maximum: {
                                value: 5,
                                unit: "C"
                              },
                              type: "temperatureConstraint"
                            }
                          },
                          associationType: "inline"
                        },
                        type: "items"
                      },
                      description: "string"
                    },
                    {
                      associationType: "inline",
                      entity: {
                        id: "903807df-ee62-47aa-bf8e-7efd747618ce",
                        description: "Box of bananas",
                        remark: "Please deliver in time, we want fresh bananas",
                        barCode: "CSE370",
                        productType: "Fruit",
                        packagingMaterial: "Box",
                        constraint: {
                          entity: {
                            value: {
                              constraintType: "maximum",
                              maximum: {
                                value: 5,
                                unit: "C"
                              },
                              type: "temperatureConstraint"
                            }
                          },
                          associationType: "inline"
                        },
                        type: "items"
                      },
                      description: "string"
                    }
                  ],
                  actions: [
                    {
                      associationType: "inline",
                      entity: {
                        id: "e81a7aa3-23a6-4089-b916-52b854c7b6f1",
                        lifecycle: "planned",
                        remark: "",
                        startTime: "2021-06-23T14:00:00Z",
                        endTime: "2021-06-23T14:15:00Z",
                        actionType: "load",
                        location: [
                          {
                            associationType: "inline",
                            entity: {
                              id: "11c11d75-e114-4b5f-9751-b3a4afa23ecf",
                              name: "Main warehouse",
                              geoReference: {
                                lat: 5.4126792,
                                lon: 52.1956251,
                                type: "latLonPointGeoReference"
                              },
                              type: "warehouse",
                              administrativeReference: {
                                name: "Supermarket warehouse",
                                street: "Valutaboulevard",
                                houseNumber: "16",
                                houseNumberAddition: "C",
                                postalCode: "1825BT",
                                city: "Amersfoort",
                                country: "NL"
                              },
                              contactDetails: [
                                {
                                  value: "+312012345678",
                                  remark: "private cellphone of the CEO",
                                  language: "nld",
                                  type: "phone"
                                }
                              ]
                            }
                          }
                        ]
                      },
                      description: "string"
                    },
                    {
                      associationType: "inline",
                      entity: {
                        id: "5d7a7aa3-a7c1-6275-b916-52b854c7c71a",
                        lifecycle: "planned",
                        remark: "",
                        startTime: "2021-06-24T14:00:00Z",
                        endTime: "2021-06-24T14:15:00Z",
                        actionType: "unload",
                        location: [
                          {
                            associationType: "inline",
                            entity: {
                              id: "11c11d75-e114-4b5f-9751-b3a4afa23ecf",
                              name: "Main warehouse",
                              geoReference: {
                                lat: 6.4126792,
                                lon: 53.1956251,
                                type: "latLonPointGeoReference"
                              },
                              type: "warehouse",
                              administrativeReference: {
                                name: "Supermarket warehouse",
                                street: "BarendStrasse",
                                houseNumber: "3",
                                postalCode: "48267",
                                city: "Berlin",
                                country: "DE"
                              }
                            }
                          }
                        ]
                      },
                      description: "string"
                    }
                  ]
                },
                associationType: "inline"
              }
            ]
          }
    }
}

export default OrderGenerator;